import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SHARED_MODULES, SHARED_TUAIN_FORMS, SHARED_WIDGET_COMPONENTS } from '@shared/shared-standalone';

@Component({
  standalone: true,
  selector: 'notfound',
  imports: [...SHARED_MODULES, ...SHARED_TUAIN_FORMS, ...SHARED_WIDGET_COMPONENTS],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: '../../../templates/auth/notfound/notfound.component.html',
})
export class NotFoundComponent {}
